/*
 * Copyright (c) 2024-2025 GM Global Technology Operations LLC. All rights reserved.
 * This information is confidential and proprietary to GM Global Technology
 * Operations LLC and may not be used, modified, copied or distributed.
 */

import {ValidationModel} from './validation.model';

export class ProgramSize extends ValidationModel {
    static sizes = ['XXL', 'XL', 'L', 'M', 'S', 'XS', ''];
    // GME, GMI will not appear in chart by default, the rest will
    static regions = ['US', 'GMSA', 'GMK', 'GMM', 'PATAC', 'GME', 'GMI', ''];

    id: number;
    programName: string;
    momentumId: string;
    size: string;
    sorpDate: Date;
    region: string;
    createdDate: Date;
    updatedDate: Date;
    createdBy: string;

    fieldRules = [
        {fieldName: 'programName', required: true, maxLength: 500, uniqueFieldSetName: 'set1', forErrorMessage: 'Program Name'},
        {fieldName: 'momentumId', required: false, maxLength: 50, uniqueFieldSetName: 'set1', forErrorMessage: 'Momentum ID'},
    ]

    setData(result) {
        this.id = result.id;
        this.programName = result.programName;
        this.momentumId = result.momentumId;
        this.size = result.size;
        this.sorpDate = new Date(result.sorpDate);
        // make sure region exists in our list of valid regions
        this.region = ProgramSize.checkRegion(result.region);
        this.createdDate = new Date(result.Created_Date);
        this.updatedDate = new Date(result.Updated_Date);
        this.createdBy = result.Created_By;
    }

    // Current regions in momentum and Brian's requirements
    // 1 = "GMI" -> This is a valid region, but we do not include these in the chart by default
    // 2 = "GMGC" -> PATAC
    // 3 = "GMI (Korea), GMNA" -> blank
    // 4 = "Renault" -> blank
    // 5 = "GMGC, GMNA" -> blank
    // 6 = "GME, GMNA" -> blank
    // 7 = "GME (AVTOVAZ)" -> GME
    // 8 = "GMSA" -> GMSA
    // 9 = "Fiat" -> blank
    // 10 = "GMNA" -> blank
    // 11 = "GMGC (PATAC)" -> PATAC
    // 12 = "GMI (Korea)" -> GMK
    // 13 = "GME" -> This is a valid region, but we do not include these in the chart by default
    // 14 = "GMI (Holden)" -> blank
    // 15 = "PSA" -> blank
    private static checkRegion(region : string): string {
        if (!region) {
            return '';
        }
        // use comments above to take input region and return valid response
        if (region === 'GMGC') {
            return 'PATAC';
        }
        if (region === 'GMI (Korea)') {
            return 'GMK';
        }
        const upperRegion = region.toUpperCase().trim();
        for (const allowedRegion of ProgramSize.regions) {
            if (!allowedRegion) {
                continue;
            }
            const upperAllowed = allowedRegion.toUpperCase().trim();
            if (upperRegion === upperAllowed) {
                return allowedRegion;
            }
            if (upperRegion.startsWith(upperAllowed)) {
                return allowedRegion;
            }
        }
        return '';
    }
}
